import React, { PureComponent, PropTypes } from 'react';
import moment from 'moment';

import { getStartEndTimesBasedOnBookingStatus } from '../../../util/bookingHelpers';

import './Header.css';

export default class Header extends PureComponent {
    static propTypes = {
        start: PropTypes.object,
        end: PropTypes.object,
        onClose: PropTypes.func,
        onSave: PropTypes.func.isRequired,
        hasButtons: PropTypes.bool.isRequired,
        title: PropTypes.string,
    }

    constructor(props) {
        super(props);

        this.handleCloseClick = this.handleCloseClick.bind(this);
        this.handleSaveClick = this.handleSaveClick.bind(this);
    }

    handleCloseClick() {
        if (this.props.onClose)
            this.props.onClose();
    }

    handleSaveClick() {
        this.props.onSave();
    }

    pluralize(count, singular) {
        return count > 1 ? `${singular}s` : singular;
    }

    formatDuration(duration) {
        let days = Math.floor(duration.asDays());
        const daysStr = days > 0 ? `${days} ${this.pluralize(days, `day`)},` : ``;
        let hours = duration.hours();
        const hoursStr = hours > 0 ? ` ${hours} ${this.pluralize(hours, `hour`)},` : ``;
        let minutes = duration.minutes();
        const minutesStr = minutes > 0 ? ` ${minutes} ${this.pluralize(minutes, `minute`)}` : ``;

        // Return the final string that has all spaces and , trimmed off both ends.
        return `${daysStr}${hoursStr}${minutesStr}`.trim().replace(/,+$/, ``);
    }

    render() {
        const { booking, start, end, hasButtons, title } = this.props;
        const topHeadingText = title || `${start.format(`HH:mm`)} - ${end.format(`HH:mm`)}`;
        const duration = moment.duration(end.diff(start));

        const closeButtonJsx = hasButtons
            ? <i className="material-icons" onClick={this.handleCloseClick}>&#xE5CD;</i>
            : null;
        const saveButtonJsx = hasButtons
            ? <i className="material-icons" onClick={this.handleSaveClick}>&#xE5CA;</i>
            : null;

        return (
            <header className="time-selector-header">
                <div className="title">
                    <div className="column left-column">{closeButtonJsx}</div>
                    <div className="time">
                        <h2>{topHeadingText}</h2>
                        <h1>{this.formatDuration(duration)}</h1>
                    </div>
                    <div className="column right-column">{saveButtonJsx}</div>
                </div>
                <div className="column-headings">
                    <div className="column left-column">HOUR</div>
                    <div className="spacer"></div>
                    <div className="column right-column">{start.format(`MMM`).toUpperCase()}</div>
                </div>
            </header>
        );
    }
}



// WEBPACK FOOTER //
// ./scripts/components/Common/TimeSelector/Header.jsx